module.exports = __webpack_public_path__ + "img/papaya_title.9e2a0374.svg";